import { render, staticRenderFns } from "./baiguullaga_slide.vue?vue&type=template&id=d79842fa&scoped=true&"
import script from "./baiguullaga_slide.vue?vue&type=script&lang=js&"
export * from "./baiguullaga_slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79842fa",
  null
  
)

export default component.exports